<p-card class="p-shadow-4">
    <div class="colSub">
        <h5 class="numbCust">{{numb}}</h5>
        <h5 class="subCust">{{subTitle}}</h5><br />
        <i [ngClass]="icontitle" class="fs27"></i>
    </div>
</p-card>